import { type ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { PageErrorState } from './PageErrorState';

export function AppErrorBoundary({ children }: { children: ReactNode }): JSX.Element {
  return (
    <ErrorBoundary
      FallbackComponent={({ error, resetErrorBoundary }) => (
        <PageErrorState error={error} onRetry={resetErrorBoundary} />
      )}
    >
      {children}
    </ErrorBoundary>
  );
}
